import { ValidationRule } from "react-hook-form";

const NO_MATCH_BASE = "you entered don't match";

export const FORM_ERRORS = {
  accountNoMatch: `Account Numbers ${NO_MATCH_BASE}`,
  emailsNoMatch: `Email addresses ${NO_MATCH_BASE}`,
  passwordsNoMatch: `Passwords ${NO_MATCH_BASE}`,
  emailPattern: "Please enter a valid email",
  required: "This field is required",
  passwordHintContains: "Password hints cannot contain your password",
};

export const emailPattern: ValidationRule<RegExp> = {
  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  message: FORM_ERRORS.emailPattern,
};

const validateMatch = (a: string | undefined, b: string | undefined, error: keyof typeof FORM_ERRORS) =>
  a === b ? true : FORM_ERRORS[error];

export const validateEmailsMatch = (email: string | undefined, confirm: string | undefined) =>
  validateMatch(email, confirm, "emailsNoMatch");

export const validatePasswordsMatch = (pass: string | undefined, confirm: string | undefined) =>
  validateMatch(pass, confirm, "passwordsNoMatch");

export const validatePasswordHintContains = (hint: string | undefined, pass = "") =>
  hint?.toLocaleLowerCase().includes(pass.toLowerCase()) ? FORM_ERRORS.passwordHintContains : true;
